// extracted by mini-css-extract-plugin
export default {"root":"ExpandableText_root__WSs0Y","text":"ExpandableText_text__ZOPEs","collapsible":"ExpandableText_collapsible__G93Ah","label":"ExpandableText_label__y0Eru"};